<template>
  <div class="Activity">
    <activity_info :info="activity.info"></activity_info>
    <activity_hightlights :hl="activity.hl"></activity_hightlights>
    <activity_rewards :rewards="rewards"></activity_rewards>
  </div>
</template>

<script>
 import ActivityInfo from '@/components/frontpage/ActivityInfo.vue';
 import ActivityHighlights from '@/components/frontpage/ActivityHighlights.vue';
 import ActivityRewards from '@/components/frontpage/ActivityRewards.vue';
 export default {
   name: 'Activity',
   props: ['activity'],
   computed: {
     rewards() {
       return this.$store.state.frontpage.rewards
     }
   },
   components: {
     activity_hightlights: ActivityHighlights,
     activity_info: ActivityInfo,
     activity_rewards: ActivityRewards
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Activity{
   background-image: url(~@/assets/image/frontpage/bg-info.png);
   background-size: 100%;
   width: 100%;
   min-height: 91.67vw;
   /* min-height: 61.67vw; */
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: space-around;
 }

@media (min-width: 320px) and (max-width: 480px) {
  .Activity{
    height: 130vw;
  }
 }
</style>
